<template>
  <w-modal
    v-model="show"
    :submit-button="$t('buttons.save')"
    :title="$t(title)"
    :close-button="$t('buttons.cancel')"
    :close-on-submit="false"
    :hideOnOverlay="false"
    :hideOnEsc="false"
    @submit="save()"
    @close="close()"
  >
    <div class="row">
      <div class="form-group col-12">
        <p>{{ $t("messages.offer.wantToBe") }}</p>

        <w-radio
          v-for="(item, index) in types"
          :key="item.text + index"
          class="my-2"
          :model="$schema.type"
          :value="item.value"
          :title="item.text"
        />
      </div>

      <div class="form-group col-md-12">
        <w-textarea
          class="offer-textarea"
          :model="$schema.content"
          :title="$t($schema.content.$schema.title)"
        />
      </div>
    </div>
  </w-modal>
</template>

<script>
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/offer.schema';
import { OfferType, OfferTypeTranslation } from '../../enums/offerType.enum';

const emptyData = () => ({ content: '', type: undefined });

// @vuese
// Modal wniosków
// @group Club
export default {
  mixins: [manageMixin('offer', {}, emptyData)],
  schema,
  props: {
    // Id klubu
    clubId: {
      type: Number,
      required: true
    },
    // Id profilu który składa wniosek
    profileId: {
      type: Number,
      required: true
    }
  },
  computed: {
    title() {
      return this.id ? 'modals.offer-edit' : 'modals.offer-add';
    },
    types() {
      return Object.keys(OfferType).map(item => ({
        text: this.$t(OfferTypeTranslation[OfferType[item]]),
        value: item
      }));
    }
  },
  created() {
    this.$schema.$model.clubId = this.clubId;
    this.$schema.$model.profileId = this.profileId;
  }
};
</script>

<style>
.offer-textarea textarea {
  min-height: 100px !important;
}
</style>
